import { SETTINGS_PATH } from "../const";

export const PROFILE_SUBPATH = "profile";
export const SETTINGS_PROFILE_PATH = `${SETTINGS_PATH}/${PROFILE_SUBPATH}`;
